import { createFileRoute } from '@tanstack/react-router';
import { ClientIntakeWizard } from '@/features/client-intake/ClientIntakeWizard';

/**
 * Caricamento di avvio di un cliente nuovo: dal foglio compilato alle otto anagrafiche, in
 * una transazione sola. Riservato al super-amministratore, come l'endpoint che usa.
 */
export const Route = createFileRoute('/_app/admin/client-intake')({ component: ClientIntakeWizard });
